<template>
  <div v-if="isNested">
    <FormInputs :context="context" />
  </div>

  <FormulateForm v-else v-model="keywordsForm" @submit="onSubmit">
    <FormInputs :context="context" />
  </FormulateForm>
</template>

<script>
import { defineComponent, ref } from 'vue'

const CONTEXT_DEFAULT = 'connections'
const FormInputs = defineComponent({
  name: 'FormInputs',

  props: {
    context: {
      type: String,
      default: CONTEXT_DEFAULT,
    },
  },

  setup(props) {
    return {
      placeholder: `Search ${props.context}`,
    }
  },

  template: `
    <div class="flex flex-row">
      <FormulateInput
        name="keywords"
        :placeholder="placeholder"
        :outer-class="['-mr-2 w-48 lg:w-80']"
        :input-class="['rounded-md']"
      />

      <FormulateInput
        type="submit"
        :wrapper-class="['mb-0']"
        :input-class="['mb-0 h-12']"
      >
        <span class="hidden sm:block">Search</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 sm:hidden">
          <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z" clip-rule="evenodd" />
        </svg>
      </FormulateInput>
    </div>
  `,
})

export default defineComponent({
  name: 'FilterFormKeywords',

  components: {
    FormInputs,
  },

  props: {
    isNested: {
      type: Boolean,
      default: true,
    },

    context: {
      type: String,
      default: CONTEXT_DEFAULT,
    },
  },

  emits: ['on-submit'],

  setup(_, { emit }) {
    const keywordsForm = ref({
      keywords: null,
    })

    const onSubmit = (formData) => {
      emit('on-submit', formData)
    }

    return {
      keywordsForm,
      onSubmit,
    }
  },
})
</script>
